import React, { FC, useMemo } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { PDFViewer } from '@react-pdf/renderer';
import { useQuery } from 'react-query';

import { fetchSkusByManufacturer } from 'api/sku';
import PurchaseOrderPdfTemplate from 'components/pdfs/PurchaseOrderPdfTemplate';

import {
  CreatePurchaseOrderFormValues,
  getShipToContactDetails,
  mapFormValuesToPdfData,
} from './CreatePurchaseOrderModal.utils';

type PurchaseOrderPdfPreviewProps = {
  values: CreatePurchaseOrderFormValues;
  manufacturerName: string;
  destinationHubName: string;
  shipToContact: string;
  shipToContactPhone: string;
  shipToContactEmail: string;
};

const PurchaseOrderPdfPreview: FC<PurchaseOrderPdfPreviewProps> = ({
  values,
  manufacturerName,
  destinationHubName,
  shipToContact,
  shipToContactPhone,
  shipToContactEmail,
}) => {
  const { data: skus = [] } = useQuery(
    ['fetch-skus-by-manufacturer', values.manufacturerId],
    () => fetchSkusByManufacturer(values.manufacturerId),
    { enabled: Boolean(values.manufacturerId) },
  );

  const pdfData = useMemo(
    () =>
      mapFormValuesToPdfData(
        values,
        {
          manufacturerName,
          destinationHubName,
          shipToContact,
          shipToContactPhone,
          shipToContactEmail,
        },
        skus,
      ),
    [
      values,
      manufacturerName,
      destinationHubName,
      shipToContact,
      shipToContactPhone,
      shipToContactEmail,
      skus,
    ],
  );

  const hasPreviewData = Boolean(values.poNumber || values.manufacturerId);

  if (!hasPreviewData) {
    return (
      <Box p={4}>
        <Text fontWeight="bold" mb={2}>
          PDF Preview
        </Text>
        <Text fontSize="sm" color="gray.600">
          Fill in purchase order details to preview the PDF.
        </Text>
      </Box>
    );
  }
  console.log('pdfdata', pdfData);

  return (
    <Box
      display="flex"
      flexDirection="column"
      flex="1"
      minH={0}
      overflow="hidden">
      <Text fontWeight="bold" mb={2} flexShrink={0}>
        PDF Preview
      </Text>
      <Box
        flex="1"
        minH={0}
        border="1px solid"
        borderColor="gray.200"
        borderRadius="8px"
        overflow="hidden"
        bg="white">
        <PDFViewer width="100%" height="100%" showToolbar={false}>
          <PurchaseOrderPdfTemplate data={pdfData} />
        </PDFViewer>
      </Box>
    </Box>
  );
};

export default PurchaseOrderPdfPreview;
